import "core-js/modules/es6.string.small";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import slug from 'slugify';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import MdmBreadcrumb from '~/components/atoms/Global/MdmBreadcrumb.vue';

var GlobalTitle = function GlobalTitle() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalTitle.vue');
};

export default {
  name: 'ArticleTemplate',
  components: {
    GlobalTitle: GlobalTitle,
    MdmBreadcrumb: MdmBreadcrumb
  },
  props: {
    payload: {
      type: Object,
      required: true
    },
    tags: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    breadcrumb: function breadcrumb() {
      return [{
        label: this.$t('home'),
        url: "/".concat(this.locale.market, "/").concat(this.locale.language)
      }, {
        label: this.tags[0] || '',
        url: "/".concat(this.locale.market, "/").concat(this.locale.language, "/e/magazine/").concat(slug(this.tags[0], {
          lower: true
        })) || ''
      }, {
        label: this.currentPayload.title.text,
        url: ''
      }];
    },
    formattedDate: function formattedDate() {
      var _ref22;

      var date = new Date(((_ref22 = this.payload) != null ? _ref22.date : _ref22) || null);
      var locale = "".concat(this.locale.language, "-").concat(this.locale.market);
      var options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      };
      return date.toLocaleDateString(locale, options);
    },
    currentPayload: function currentPayload() {
      var _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21;

      return {
        title: ((_ref21 = this.payload) != null ? (_ref21 = _ref21.main_title) != null ? _ref21[0] : _ref21 : _ref21) || {},
        secondTitle: ((_ref20 = this.payload) != null ? (_ref20 = _ref20.main_title) != null ? (_ref20 = _ref20[1]) != null ? _ref20.text : _ref20 : _ref20 : _ref20) || false,
        description: ((_ref19 = this.payload) != null ? (_ref19 = _ref19.description) != null ? (_ref19 = _ref19[0]) != null ? _ref19.text : _ref19 : _ref19 : _ref19) || '',
        image: {
          alt: ((_ref18 = this.payload) != null ? (_ref18 = _ref18.image) != null ? _ref18.alt : _ref18 : _ref18) || '',
          small: formatPrismicImage((_ref17 = this.payload) != null ? (_ref17 = _ref17.image) != null ? (_ref17 = _ref17.small) != null ? _ref17.url : _ref17 : _ref17 : _ref17) || EMPTY_PIXEL,
          medium: formatPrismicImage((_ref16 = this.payload) != null ? (_ref16 = _ref16.image) != null ? (_ref16 = _ref16.medium) != null ? _ref16.url : _ref16 : _ref16 : _ref16) || EMPTY_PIXEL,
          large: formatPrismicImage((_ref15 = this.payload) != null ? (_ref15 = _ref15.image) != null ? (_ref15 = _ref15.large) != null ? _ref15.url : _ref15 : _ref15 : _ref15) || EMPTY_PIXEL,
          text: ((_ref14 = this.payload) != null ? _ref14.text : _ref14) || '',
          tracking: {
            data: {
              event_category: ((_ref13 = this.payload) != null ? _ref13.event_category : _ref13) || '',
              event_action: ((_ref12 = this.payload) != null ? _ref12.event_action : _ref12) || '',
              event_label: ((_ref11 = this.payload) != null ? _ref11.event_label : _ref11) || ''
            }
          }
        }
      };
    },
    articleLdJson: function articleLdJson() {
      return this.structuredData ? {
        type: 'application/ld+json',
        innerHTML: JSON.stringify(this.structuredData)
      } : false;
    },
    structuredData: function structuredData() {
      var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10;

      var fullText = this.payload.body.filter(function (e) {
        return e.slice_type === 'article_paragraph';
      }).map(function (e) {
        return e.primary.title.concat(e.primary.text);
      }).reduce(function (f, g) {
        return f.concat(g);
      }, []).map(function (e) {
        return e.text;
      }).join(' ');
      return {
        '@context': 'http://schema.org',
        '@type': 'NewsArticle',
        image: {
          '@type': 'ImageObject',
          width: ((_ref10 = this.payload) != null ? (_ref10 = _ref10.image) != null ? (_ref10 = _ref10.large) != null ? (_ref10 = _ref10.dimensions) != null ? _ref10.width : _ref10 : _ref10 : _ref10 : _ref10) || '',
          height: ((_ref9 = this.payload) != null ? (_ref9 = _ref9.image) != null ? (_ref9 = _ref9.large) != null ? (_ref9 = _ref9.dimensions) != null ? _ref9.height : _ref9 : _ref9 : _ref9 : _ref9) || '',
          url: formatPrismicImage(this.payload.image.large.url) || EMPTY_PIXEL
        },
        dateCreated: ((_ref8 = this.payload) != null ? _ref8.date : _ref8) || '',
        datePublished: ((_ref7 = this.payload) != null ? _ref7.date : _ref7) || '',
        dateModified: ((_ref6 = this.payload) != null ? _ref6.date : _ref6) || '',
        headline: "".concat(((_ref5 = this.payload) != null ? (_ref5 = _ref5.main_title) != null ? (_ref5 = _ref5[0]) != null ? _ref5.text : _ref5 : _ref5 : _ref5) || '').concat(((_ref4 = this.payload) != null ? (_ref4 = _ref4.main_title) != null ? (_ref4 = _ref4[1]) != null ? _ref4.text : _ref4 : _ref4 : _ref4) || ''),
        name: "".concat(((_ref3 = this.payload) != null ? (_ref3 = _ref3.main_title) != null ? (_ref3 = _ref3[0]) != null ? _ref3.text : _ref3 : _ref3 : _ref3) || '').concat(((_ref2 = this.payload) != null ? (_ref2 = _ref2.main_title) != null ? (_ref2 = _ref2[1]) != null ? _ref2.text : _ref2 : _ref2 : _ref2) || ''),
        thumbnailUrl: formatPrismicImage(this.payload.image.small.url) || EMPTY_PIXEL,
        author: {
          '@type': 'Organization',
          name: 'Maisons du Monde',
          url: 'https://www.maisonsdumonde.com/'
        },
        creator: ['Maisons du Monde'],
        publisher: {
          '@type': 'Organization',
          name: 'Maisons du Monde',
          url: 'https://www.maisonsdumonde.com/'
        },
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': "".concat(this.$route.path)
        },
        articleBody: fullText,
        description: ((_ref = this.payload) != null ? (_ref = _ref.description) != null ? (_ref = _ref[0]) != null ? _ref.text : _ref : _ref : _ref) || ''
      };
    }
  }),
  head: function head() {
    return {
      script: [this.articleLdJson]
    };
  }
};